import React from 'react';
import { getLabel } from '../../data/labels';
import { ReactComponent as RouletteIcon } from '../../assets/roulette.svg';
import useOpenRoulette from './useOpenRoulette';

export default function RouletteButton(props) {
    const openRoulette = useOpenRoulette(props.conf);

    if (openRoulette == null) {
        return null;
    }

    return (
        <>
            <div className="xs_rouletteButton shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7" onClick={openRoulette}>
                <div className="xs-sport-icon col-start-1 col-end-3 justify-self-center inline-block w-[24px] h-[24px]">
                    <RouletteIcon />
                </div>
                <div className="col-start-3 col-end-11 font-medium text-sm text-cs-3">{getLabel('roulette.title', 'Live Roulette')}</div>
            </div>
        </>
    );
}